import React, { ReactNode } from "react";
import { useNavigate } from "react-router-dom";

import { RegistroCondominioDTO } from "../../types/dto/RegistroCondominioDTO";
import { LinhaTabela } from "shared/components/table/LinhaTabela";
import { RegistroTabela } from "shared/components/table/RegistroTabela";
import { Col, Container } from "react-bootstrap";
import { Row } from "antd";
import CustomButton from "shared/components/button/CustomButton";
import { Rotas } from "constants/EnumRotas";
import { BsChevronRight } from "react-icons/bs";
import { usePermissoesContext } from "context/permissoes/PermissoesContext";
import { TipoPermissao } from "constants/EnumTipoPermissao";
interface RenderRowsProps {
  registros: RegistroCondominioDTO[];
}

export const RenderRowsCondominioGestaoCobranca: React.FC<RenderRowsProps> = (props) => {
  const navigate = useNavigate();
  const { usuarioPossuiPermissao } = usePermissoesContext();
  const possuiPermissaoIncluirGestaoCobranca = usuarioPossuiPermissao(
    "gestaoCobrancas",
    TipoPermissao.INCLUIR
  );

  const handleButtonClick = (id: number, nome: string) => {
    const dadosCondominio = { condominioId: id, nomeCondominio: nome };
    navigate(Rotas.GESTAO_COBRANCAS_CADASTRO, { state: dadosCondominio });
  };

  const renderRegistros = (registros: RegistroCondominioDTO[]): ReactNode => {
    return registros.map((condominio: RegistroCondominioDTO, index: number) => {
      return (
        <LinhaTabela
          id={`id-registro-gestao-cobranca-${index}`}
          key={`key-registro-gestao-cobranca-${index}`}
        >
          <RegistroTabela
            id={`registro-condominio-${condominio.id}`}
            key={`registro-condominio-${condominio.id}`}
          >
            <Container>
              <Row className="label-condominio">
                <Col xs="10">
                  <span>{condominio.nomeFantasia}</span>
                </Col>
                {possuiPermissaoIncluirGestaoCobranca && (
                  <Col xs="2" className="btn-mais-detalhes">
                    <CustomButton
                      id={`botao-mais-detalhes-gestao-cobranca-${index}`}
                      label="Mais detalhes"
                      className="btn-sm border-radios"
                      rigthIcon={BsChevronRight}
                      onClick={() => handleButtonClick(condominio.id, condominio.nomeFantasia)}
                    />
                  </Col>
                )}
              </Row>
            </Container>
          </RegistroTabela>
        </LinhaTabela>
      );
    });
  };

  return <>{props.registros.length > 0 && renderRegistros(props.registros)}</>;
};
